/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Subscription_TermsInputs */

const en_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Benefits`)
};

const ar_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فوائد الاشتراك`)
};

const de_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorteile des Abonnements`)
};

const es_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beneficios de la suscripción`)
};

const fr_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avantages de l'abonnement`)
};

const it_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vantaggi dell'abbonamento`)
};

const ja_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション特典`)
};

const ko_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 혜택`)
};

const pt_br_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefícios da assinatura`)
};

const ru_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преимущества подписки`)
};

const th_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิทธิประโยชน์ของการสมัครสมาชิก`)
};

const tr_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Hakları`)
};

const zh_cn_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员权益说明`)
};

const zh_tw_subscription_detail_subscription_terms = /** @type {(inputs: Subscription_Detail_Subscription_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱權益說明`)
};

/**
* | output |
* | --- |
* | "Subscription Benefits" |
*
* @param {Subscription_Detail_Subscription_TermsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_subscription_terms = /** @type {((inputs?: Subscription_Detail_Subscription_TermsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Subscription_TermsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_subscription_terms(inputs)
	if (locale === "ar") return ar_subscription_detail_subscription_terms(inputs)
	if (locale === "de") return de_subscription_detail_subscription_terms(inputs)
	if (locale === "es") return es_subscription_detail_subscription_terms(inputs)
	if (locale === "fr") return fr_subscription_detail_subscription_terms(inputs)
	if (locale === "it") return it_subscription_detail_subscription_terms(inputs)
	if (locale === "ja") return ja_subscription_detail_subscription_terms(inputs)
	if (locale === "ko") return ko_subscription_detail_subscription_terms(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_subscription_terms(inputs)
	if (locale === "ru") return ru_subscription_detail_subscription_terms(inputs)
	if (locale === "th") return th_subscription_detail_subscription_terms(inputs)
	if (locale === "tr") return tr_subscription_detail_subscription_terms(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_subscription_terms(inputs)
	return zh_tw_subscription_detail_subscription_terms(inputs)
});